// Imports an instance axios with all defaults and interceptors setup.

export default class Response {
	
	constructor(){
		let response = {
			data:{
				data:{
					message:"",
					error:"",
					data:""
				},
				
			}
		}
		this.setResponse(response);
		return this;
	}

	getResponseData(){
		return !!this._response.data.data ? this._response.data.data : "";
	}
	getResponseError(){
		return !!this._response.data.error ? this._response.data.error : "";
	}
	getResponseMessages(){
		return !!this._response.data.messages ? this._response.data.messages : "";
	}
	getResponse(){
		return this._response;
	}

	setResponse(response){
		this._response = response;
	}


}
